import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useEffect, useState } from "react";

export function ProtectedRoute({ children }) {
  console.log("ProtectedRoute component rendering");
  const location = useLocation();
  const { user, isLoading, error } = useAuth();
  const [renderError, setRenderError] = useState(null);
  
  useEffect(() => {
    console.log("ProtectedRoute - Current path:", location.pathname);
    console.log("ProtectedRoute - Auth state:", { 
      isAuthenticated: !!user, 
      isLoading,
      authError: error,
      userInfo: user ? {
        uid: user.uid,
        email: user.email,
        name: user.name
      } : null 
    });
  }, [location.pathname, user, isLoading, error]);
  
  // Handle loading state
  if (isLoading) {
    console.log("ProtectedRoute - Auth is still loading, showing loading indicator");
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#121212]">
        <div className="text-center">
          <svg className="animate-spin h-10 w-10 text-[#ff1b6d] mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p className="mt-3 text-white">Verificando autenticación...</p>
        </div>
      </div>
    );
  }
  
  // Handle unauthenticated state
  if (!user) {
    console.log("ProtectedRoute - User not authenticated, redirecting to login");
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Handle authentication errors
  if (error) {
    console.error("ProtectedRoute - Auth error:", error);
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#121212]">
        <div className="bg-[#1e1e1e] rounded-lg p-6 max-w-md mx-auto">
          <h2 className="text-xl font-bold text-white mb-4">Error de autenticación</h2>
          <p className="text-gray-300 mb-4">{error}</p>
          <button 
            onClick={() => window.location.href = '/login'} 
            className="px-4 py-2 bg-[#ff1b6d] text-white rounded-md hover:bg-[#ff1b6d]/90"
          >
            Volver a iniciar sesión
          </button>
        </div>
      </div>
    );
  }

  console.log("ProtectedRoute - User authenticated, rendering children");
  
  // Error boundary using try/catch and state
  if (renderError) {
    console.error("ProtectedRoute - Render error:", renderError);
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#121212]">
        <div className="bg-[#1e1e1e] rounded-lg p-6 max-w-md mx-auto">
          <h2 className="text-xl font-bold text-white mb-4">Error de renderizado</h2>
          <p className="text-gray-300 mb-4">Ocurrió un error al mostrar esta página: {renderError.message}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-[#ff1b6d] text-white rounded-md hover:bg-[#ff1b6d]/90"
          >
            Recargar página
          </button>
        </div>
      </div>
    );
  }

  // Try to render children with error handling
  try {
    return children;
  } catch (err) {
    console.error("ProtectedRoute - Error rendering protected content:", err);
    setRenderError(err);
    return null; // Will be replaced with error UI on next render
  }
}
